// extracted by mini-css-extract-plugin
export default {"switch__container":"RequesteeSearch_switch__container__9xg4a","footer":"RequesteeSearch_footer__l8+Ru","body__container":"RequesteeSearch_body__container__Gh9Yc"};